// import enquire from 'enquire.js';
// eslint-disable-next-line no-unused-vars
// import TweenMax from '../vendor/TweenMax.min.js';
// import wavify from '../vendor/wavify.js';

export default {
	init() {
		// JavaScript to be fired on the home page
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
		/*
		/* Wavify */
		/*
		const messageDivider = document.querySelector('.divider.message');
		const messageDivider1 = document.querySelector('.divider.message #wavify-one');
		const messageDivider2 = document.querySelector('.divider.message #wavify-two');
		// let shhred = getComputedStyle(document.querySelector(':root')).getPropertyValue('--shh-red'); //too much hassle
		let shortwave1;
		let shortwave2;

		if (messageDivider) {
			enquire.register('screen and (min-width: 64rem)', {
				setup : function() {
					// https://github.com/peacepostman/wavify
					shortwave1 = wavify(messageDivider1, {
						height: 60,
						bones: 4,
						amplitude: 50,
						color: '#dd2545',
						speed: .05
					});
					shortwave2 = wavify(messageDivider2, {
						height: 80,
						bones: 3,
						amplitude: 40,
						color: '#dd2545',
						speed: .1
					});

					shortwave1.pause();
					shortwave2.pause();
				},
				match : function() {
					shortwave1.play();
					shortwave2.play();

					messageDivider.addEventListener('click', function() {
						shortwave1.pause();
						shortwave2.pause();
					});
				},
				unmatch : function() {
					shortwave1.pause();
					shortwave2.pause();
				}
			});
		}
		*/
	}
};
